// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eS0Gq{position:relative;margin:24px 0 32px}@media screen and (min-width:768px){.eS0Gq{margin:48px 0}}.\\+a631 .sG8Ev{margin-top:0;margin-bottom:0}.Da3au{min-height:104px}@media screen and (min-width:768px){.Da3au{min-height:120px}}.u9kSJ{display:flex;overflow:hidden;height:100%;min-height:96px;flex-flow:column;align-items:center;padding:0 24px 24px;margin:0 -16px;background:#e2e2e2}@media screen and (min-width:768px){.u9kSJ{padding-bottom:24px;margin:0}}.u9kSJ .TgIhf{height:100%}@media screen and (min-width:768px){.u9kSJ .TgIhf{width:100%}}.u9kSJ [id^=adfox]{display:flex;width:100%!important;height:100%;align-items:center;justify-content:center}.u9kSJ img{height:100%!important;-o-object-fit:cover;object-fit:cover}.O4-Ha{color:#989898;font-size:12px;line-height:24px}.e1hxw{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootEl": "eS0Gq",
	"boxAdfox": "+a631",
	"boxCard": "sG8Ev",
	"partnerCard": "Da3au",
	"banner": "u9kSJ",
	"adfox": "TgIhf",
	"title": "O4-Ha",
	"loader": "e1hxw"
};
module.exports = ___CSS_LOADER_EXPORT___;
